import { useAllEpisodesPageController } from '@controllers/useAllEpisodesPageController';
import AllEpisodesPageView from '@views/pages/AllEpisodesPageView';

export default function AllEpisodesPage() {
  return <AllEpisodesPageView {...useAllEpisodesPageController()} />;
}
